import { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  selectIsOrganicManagementDataLoading,
  selectOrganicRanksChartData,
  selectOrganicRanksOptions,
  selectOrganicRanksSelectedOption,
  setSelectedOrganicRankModalOption,
} from '../../../../../../store/slice/organicRankModal'
import { isRankChartKey } from '../../../helpers/format-rank-value'

export const useChart = () => {
  const chartData = useSelector(selectOrganicRanksChartData)
  const isFetching = useSelector(selectIsOrganicManagementDataLoading)
  const options = useSelector(selectOrganicRanksOptions)
  const selected = useSelector(selectOrganicRanksSelectedOption)
  const dispatch = useDispatch()

  const onSelectChange = (option) => {
    dispatch(setSelectedOrganicRankModalOption(option))
  }

  const comparedInfo = useMemo(() => {
    const info = {
      value: 0,
      isDecreased: false,
    }

    const data = chartData[selected]

    if (!data?.length) return info

    const value = data[data.length - 1].value - data[0].value

    return {
      value,
      isDecreased: value < 0,
    }
  }, [chartData, selected])

  const filteredChartData = useMemo(() => chartData[selected] || [], [chartData, selected])

  const mainLabel = useMemo(
    () => (selected && options.length ? options.find((item) => item.value === selected)?.mainLabel : ''),
    [selected, options]
  )

  return {
    chartData: filteredChartData,
    comparedValue: comparedInfo.value,
    isDecreased: comparedInfo.isDecreased,
    isFetching,
    selected,
    options,
    mainLabel,
    onSelectChange,
    isRank: isRankChartKey(selected),
  }
}
